var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"my-1"},[_c('div',{staticClass:"jumbotron"},[_c('div',{staticClass:"container text-center"},[_c('h1',[_vm._v("Home")]),_c('div',[_c('p',[_c('i',{staticClass:"tagline"},[_vm._v("A minimal Home Page")])])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }